import React from "react"
import { FormattedMessage } from "react-intl"
import { DisableRowReasonKey,
    ROW_EXCEEDS_PRICE_LIST_CAPACITY,
    ROW_INSUFFICIENT_INVENTORY,
    ROW_LIMIT_EXCEEDED
} from "../../state/pricing/DisableReasonKeys"

type OwnProps = {
    disableReasonKey: DisableRowReasonKey
}
const DisabledRowBadgeComponent = (props: OwnProps) => {
    return (
        <div className="mr-1 badge badge-danger text-with-icon">
            {getDisableMessage(props.disableReasonKey)}
        </div>
    )
}

const getDisableMessage = (disableReasonKey: DisableRowReasonKey) => {
    switch(disableReasonKey) {
    case ROW_EXCEEDS_PRICE_LIST_CAPACITY:
        return (
            <FormattedMessage
                id="quote.item.price_list_max_capacity_exceeded"
                defaultMessage="Max capacity exceeded"
            />
        )
    case ROW_INSUFFICIENT_INVENTORY:
        return (
            <FormattedMessage
                id="quote.item.unfulfillable_row"
                defaultMessage="Insufficient inventory"
            />
        )
    case ROW_LIMIT_EXCEEDED:
        return (
            <FormattedMessage
                id="quote.item.row_limit_exceeded"
                defaultMessage="Item limit exceeded"
            />
        )
    }
}

export default DisabledRowBadgeComponent


// WEBPACK FOOTER //
// ./src/quote/components/DisabledRowBadgeComponent.tsx